export default {
  "path": "/demo/hooks",
  "meta": {
    "name": "demo-Hooks Demo",
    "title": "Hooks Demo",
    "isComponentDoc": true,
    "category": "Hooks"
  }
};